import script from "./Notification.vue?vue&type=script&lang=ts&setup=true"
export * from "./Notification.vue?vue&type=script&lang=ts&setup=true"

import "./Notification.vue?vue&type=style&index=0&id=85e4ea3c&lang=scss&scoped=true"

import exportComponent from "/Users/ttheitao/Desktop/devApps/onetab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85e4ea3c"]])

export default __exports__